import type { Ref } from 'vue'
import { nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useHandleMenuClick(isOpen: Ref<boolean>, scrollOffset = 100) {
  const router = useRouter()
  const route = useRoute()

  const handleAnchorClick = async (event: MouseEvent, hash: string) => {
    if (route.path !== '/') {
      await router.push(`/${hash}`)
    }

    isOpen.value = false

    nextTick(() => {
      setTimeout(() => {
        const element = document.querySelector(hash)
        if (element) {
          const elementTop = element.getBoundingClientRect().top + window.scrollY
          const offsetPosition = elementTop - scrollOffset

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          })
        }
      }, 50)
    })
  }
  const handleItemClick = (event: MouseEvent, href: string) => {
    event.preventDefault()
    isOpen.value = false

    nextTick(() => {
      href.startsWith('#')
        ? handleAnchorClick(event, href)
        : router.push(href)
    })
  }

  return {
    handleItemClick,
    handleAnchorClick,
  }
}
